import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from "@rails/request.js";

export default class extends Controller {
  static targets = ["form", "submitDraft"];
  static values = {submitDraftPath: String};

  addInvalidClass(event) {
    event.target.classList.add("invalid:border-red-500");
  }

  async saveInput() {
    const request = new FetchRequest('put', this.submitDraftPathValue, {
      body: new FormData(this.formTarget)
    })
    await request.perform()
  }
}
